<template>
  <div>
    <div>
      <loader v-model="statusval.loading"></loader>
      <arksnackbar v-model="statusval"></arksnackbar>
    </div>
    <v-container fluid>
      <v-card color="grey lighten-5" flat>
        <v-layout row wrap>
          <v-flex xs12 sm6 md2>
            <v-form ref="formtarih" v-model="valid" lazy-validation>
              <tarihcomp etiket="Başlangıç Tarihi" :detaygizle="false" v-model="date" v-bind:defaultvalue="'ok'"
                :rules="[(v) => !!v || $t('Please-select-a-date')]"></tarihcomp>

            </v-form>
          </v-flex>
          <v-flex xs12 sm6 md2>
            <v-form ref="formtarih" v-model="valid" lazy-validation>
              <tarihcomp etiket="Bitiş Tarihi" :detaygizle="false" v-model="endDate" v-bind:defaultvalue="'ok'"
                :rules="[(v) => !!v || $t('Please-select-a-date')]"></tarihcomp>

            </v-form>
          </v-flex>

          <v-flex xs12 sm4 md2>
            <v-layout align-start="" justify-center column fill-height>
              <div>
                <v-btn small="" @mouseenter="tooltip = true" @mouseleave="tooltip = false" ref="fab" @click="Aktar()"
                  color="info" fab dark>
                  <v-icon>reply_all</v-icon>
                </v-btn>
                <v-tooltip bottom="" :activator="el" v-model="tooltip">
                  <span>{{ this.$t('Transfer-Reservations') }}</span>
                </v-tooltip>
              </div>
            </v-layout>
          </v-flex>
          <v-flex xs12 sm4 md2>
            <v-btn @click="ParametreOku()" color="primary">
              <v-icon right dark>playlist_add_check</v-icon>
              Parametreler
            </v-btn>
          </v-flex>
          <v-flex xs12 sm4 md2>
      <v-btn @click="CarileriAktar()" color="primary">
        <v-icon right dark>playlist_add_check</v-icon>
        Carileri Aktar
      </v-btn>
    </v-flex>
        </v-layout>
      </v-card>
    </v-container>

    <v-layout row wrap>
      <v-flex xs12 sm6 md6>
        <v-toolbar size="120px" dark color="info">
          <v-toolbar-title>{{
            $t("Imported-Hotel-Data")
          }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-text-field flat="" solo-inverted="" hide-details v-model="search3" :label="$t('Search')"
            append-icon="search">
          </v-text-field>
        </v-toolbar>

        <v-card>
          <v-data-table :headers="headers" :rows-per-page-items="[20, 500]" :items="itemsok" :search="search3">
            <template slot="items" slot-scope="props">
              <tr item>
                <td class="text-xs-left">{{ props.item.pnrNo }}</td>
                <td class="text-xs-left">{{ props.item.DisId }}</td>
                <td class="text-xs-left">{{ props.item.aciklama }}</td>
                <v-btn icon class="mx-0" @click="git(props.item)">
                  <v-icon color="teal">search</v-icon>
                </v-btn>
              </tr>
            </template>
            <v-alert slot="no-results" :value="true" color="error" icon="warning">
              {{ $t("No-records-searched-for", { value: search3 }) }}
            </v-alert>
          </v-data-table>
        </v-card>
      </v-flex>
      <v-flex xs12 sm6 md6>
        <v-toolbar size="120px" dark color="red">
          <v-toolbar-title>{{ $t("Error-Hotel-Data") }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-text-field flat="" solo-inverted="" hide-details v-model="search4" :label="$t('Search')"
            append-icon="search">
          </v-text-field>
        </v-toolbar>
        <v-card>
          <v-data-table :headers="headers" :rows-per-page-items="[20, 500]" :items="itemsno" :search="search4">
            <template slot="items" slot-scope="props">
              <tr item>
                <td class="text-xs-left">{{ props.item.pnrNo }}</td>
                <td class="text-xs-left">{{ props.item.DisId }}</td>
                <td class="text-xs-left">{{ props.item.aciklama }}</td>
                <v-btn v-if="props.item.pnrNo > 0" icon class="mx-0" @click="git(props.item)">
                  <v-icon color="teal">search</v-icon>
                </v-btn>
                <v-btn v-if="props.item.saticiEntegrasyon.length > 0" icon class="mx-0"
                  @click="saticiDialogAc(props.item)">
                  <v-icon color="teal">add</v-icon>
                </v-btn>
              </tr>
            </template>
            <v-alert slot="no-results" :value="true" color="error" icon="warning">
              {{ $t("No-records-searched-for", { value: search4 }) }}
            </v-alert>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
    <v-dialog v-model="dialogayarlar" scrollable="" persistent="" max-width="400px">
      <v-card color="grey lighten-5">
        <v-card-title> {{ SatisKanali }} {{ $t("Definitions") }} </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-layout row wrap>
            <v-flex xs12 sm12 md12>
              <v-text-field hide-details label='Booking URL' v-model="juniperParameter.Url">
              </v-text-field>
            </v-flex>
            <v-flex xs12 sm12 md12>
              <v-text-field hide-details label='Customer URL' v-model="juniperParameter.JuniperCustomerURL">
              </v-text-field>
            </v-flex>
            <v-flex xs12 sm12 md12>
              <v-text-field hide-details label='Invoice URL' v-model="juniperParameter.JuniperInvoiceURL">
              </v-text-field>
            </v-flex>
            <v-flex xs12 sm12 md12>
              <v-text-field hide-details :label="$t('Username')" v-model="juniperParameter.Username">
              </v-text-field>
            </v-flex>
            <v-flex xs12 sm12 md12>
              <v-text-field hide-details :label="$t('Password')" v-model="juniperParameter.Password">
              </v-text-field>
            </v-flex>
          </v-layout>
        </v-card-text>

        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click.native="dialogayarlar = false">{{ $t("cancel_button") }}</v-btn>
          <v-btn color="blue darken-1" flat @click.native="ayarkaydet()">{{
            $t("save_button")
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogaktarilanCariler" scrollable="" persistent="" max-width="400px">
      <v-card style="height: 100%;" color="grey lighten-5">
        <v-card-title> Aktarılan Cariler </v-card-title>
        <v-flex style="padding-left: 20px;" v-for="cari in aktarilanCariler">{{ cari }}</v-flex>
        <v-btn color="blue darken-1" flat @click.native="dialogaktarilanCariler = false">Kapat</v-btn>

      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import baseaktarim from "../aktarim/coperbaseaktarim";
import tool from "../tools";
import helpers from "@/components/app/customcomp/helpers.js";
import tarihcomp from "@/components/app/customcomp/tarihim";
import loader from "@/components/app/coper/comp/loader.vue";
import arksnackbar from "@/components/app/coper/comp/arksnackbar.vue";
export default {
  data() {
    return {
      items: [],
      status: tool.NewSatatus(),
      dialogayarlar: false,
      SatisKanali: "Juniper",
      aktarilanCariler: [],
      juniperParameter: {
        Url: "",
        Username: "",
        Password: "",
        JuniperCustomerURL: "",
        JuniperInvoiceURL: "",
      },
      menuItems: [
        {
          title: this.$t('Parameters'),
        },
      ],
      headers: [
        {
          text: this.$t("PNR-No"),
          value: "pnrNo",
        },
        {
          text: "Dış Id",
          value: "DisId",
        },
        {
          text: this.$t("Status"),
          value: "aciklama",
        },
      ],
      itemsno: [],
      itemsok: [],
      alertcolor: "red",
      alertmessage: this.$t("file-has-been-chosen"),
      search3: "",
      search4: "",
      EslestirmeTipi: { Key: 0, Text: "Mevcut Satıcı ile eşleştir" },
      saticidDialog: false,
      Satici: {},
      SaticiTip: 0,
      dialogaktarilanCariler: false,
      aktifPNR: null,
      aktifSatici: {
        SaticiTipi: 1,
        Kod: "",
        EntKod: "",
        Isim: "",
        Adres: "",
        PK: "",
        Ulke: "",
        Sehir: "",
        Yer: "",
        SaticiKonumu: "",
        Yetkili: "",
        Web: "",
        HavaAlani: 0,
        VDaire: "",
        VNo: "",
        Tel1: "",
        Tel2: "",
        Fax: "",
        Teleks: "",
        Email: "",
        GSM: "",
        Ic_Dis: 0,
        Aciklamalar: "",
      },

      files: [],
      valid: true,
      load2: false,
      load3: false,
      butondurum: true,
      y: "top",
      x: "right",
      mode: "",
      timeout: 6000,
      text1: "",
      tooltip: false,
      el: null,
      date: null,
      endDate: null
    };
  },

  components: {
    baseaktarim,
    tarihcomp,
    loader,
    arksnackbar,
  },
  computed: {
    statusval: {
      get: function () {
        if (this.status == null) {
          return tool.NewSatatus();
        } else {
          return this.status;
        }
      },
    },
  },
  methods: {
    ParametreOku:ParametreOku,
    menuClick(index) {
      if (index == 0) {
        this.ParametreOku();
      } else if (index == 1) {
      }
    },
    Aktar() {

      let params = {
        startDate: this.date,
        endDate: this.endDate,
      };

      this.status.loading = true;
      tool.api_post(this, "CoperStream/JuniperStream", params).then(
        (response) => {
          this.items = response.body;
          this.status.loading = false;
          this.itemsok = [];
          this.itemsno = [];
          this.items.forEach((element) => {
            if (element.basarili) {
              this.itemsok.push(element);
              //aktarilan = aktarilan + 1
            } else {
              this.itemsno.push(element);
            }
          });
          this.status.loading = false;
        },
        (response) => {
          this.status = tool.responseToStatus(response);
        }
      );
    },
    ayarkaydet() {

      tool
        .api_post(this, "CoperStream/JuniperParameterWrite", this.juniperParameter)
        .then(
          (response) => {
            this.items = response.body;
            this.status.loading = false;
            this.itemsok = [];
            this.itemsno = [];
            this.items.forEach((element) => {
              if (element.basarili) {
                this.itemsok.push(element);
                //aktarilan = aktarilan + 1
              } else {
                this.itemsno.push(element);
              }
            });
            this.status.loading = false;
          },
          (response) => {
            this.status = tool.responseToStatus(response);
          }
        );
    },
    CarileriAktar() {
      this.status.loading = true;

      tool.api_post(this, 'CoperStream/JuniperCariStream', { SatisKanali: this.SatisKanali }).then((response) => {

        this.aktarilanCariler = response.body
        this.status.loading = false;

        this.dialogaktarilanCariler = true
      }, (response) => {

        this.text1 = "Cariler getirilemedi tekrar deneyiniz."
        this.snackbar = true;
        this.status.loading = false;
      })
    }    ,
    ayarkaydet() {
      tool
        .api_post(this, "CoperStream/JuniperParameterWrite", this.juniperParameter)
        .then(
          (response) => {
            if (response.body === true) {
              this.text1 = this.$t("Your-settings-have-been-saved");
              this.snackbar = true;
              this.dialogayarlar = false;
            } else {
              this.text1 = this.$t("Error-please-try-again");
              this.snackbar = false;
            }
          },
          (response) => {
            this.text1 = this.$t("Error-please-try-again");
            this.snackbar = false;
          })
    }
  }
}
function ParametreOku() {
      tool.api_post(this, 'CoperStream/JuniperParameterRead', { SatisKanali: this.SatisKanali }).then((response) => {

        this.juniperParameter = response.body

        this.dialogayarlar = true
      }, (response) => {

        this.text1 = "Ayarlar getirilemedi tekrar deneyiniz."
        this.snackbar = false
      })
    }
</script>
